import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewCoupon, toggleCoupon } from '~/services/api'
import { CouponDTO, SchoolDTO, PackageDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    coupons: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractCouponViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            coupons: [
                {
                    code: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    days: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    package: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    school: {
                        field: 'badge',
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this.toggle = this.toggle.bind(this)
        this._handleChange = this._handleChange.bind(this)
    }

    componentDidMount() {
        this.loadCoupon()
    }

    toggle(id) {
        toggleCoupon(id, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadCoupon()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    loadCoupon() {
        this._handleChange('loading', true)
        viewCoupon(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let coupons = []
            coupons.push(this.state.coupons[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.coupon.map((item, index) => {
                    const data: CouponDTO = item
                    let text = null
                    let school = {
                        text: 'Not Assigned',
                        badge: 'table-red',
                    }
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            badge: 'table-green',
                            modal: 'modal_coupon_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            badge: 'table-red',
                            modal: 'modal_coupon_' + index,
                        }
                    }
                    if (data.school) {
                        school = {
                            text: data.school.name + ' - ' + data.school.short_code,
                            badge: 'table-green',
                        }
                    }
                    const tableData = {
                        code: {
                            text: data.code,
                        },
                        days: {
                            text: data.days,
                        },
                        package: {
                            text: data.package.name,
                        },
                        school: school,
                        status: text,
                        action: {
                            text: 'Edit',
                            route: route.superadmin.coupon.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    coupons.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                coupons,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
